module.exports = __webpack_public_path__ + "static/headerRightBg375-cb0f5dda0b6031e698f53d2d73ed41eb.png";